import React from 'react';
import PropTypes from 'prop-types';
import { EmphasisTag } from '@welldev-group/react-comp-lib';
import Button from '@welldev-group/rcl-button';

const VerificationHeader = ({
  status,
  isLoading,
  isEditing,
  isSaving,
  initialStatus,
  onEdit,
  onCancel,
  onSave,
}) => {
  const VERIFICATION_STATUS = {
    unverified: 'unverified',
    verified: 'verified',
  };

  return (
    <div className="affiliate-config-verification__header">
      <div className="affiliate-config-verification__title-status">
        <h2 className="affiliate-config-verification__title">
          {I18n.t(
            'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.header',
          )}
        </h2>
        {!isLoading && !isEditing && (
          <EmphasisTag
            size="tiny"
            type={status === VERIFICATION_STATUS.unverified ? 'danger' : 'disabled'}
            text={
              status === VERIFICATION_STATUS.unverified
                ? I18n.t(
                    'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.status.unverified',
                  )
                : I18n.t(
                    'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.status.verified',
                  )
            }
          />
        )}
      </div>

      <div className="affiliate-config-verification__actions">
        {!isEditing ? (
          <Button
            type="primary"
            size="small"
            onClick={onEdit}
            label={I18n.t(
              'components.affiliate_three_sixty.affiliate.button_label.change',
            )}
          />
        ) : (
          <>
            <Button
              type="default"
              size="small"
              label={I18n.t(
                'components.affiliate_three_sixty.affiliate.button_label.cancel',
              )}
              onClick={onCancel}
            />
            <Button
              type="primary"
              size="small"
              onClick={onSave}
              disabled={isSaving || status === initialStatus}
              label={
                isSaving
                  ? I18n.t(
                      'components.affiliate_three_sixty.affiliate.configuration.affiliate_verification.saving',
                    )
                  : I18n.t(
                      'components.affiliate_three_sixty.affiliate.button_label.save',
                    )
              }
            />
          </>
        )}
      </div>
    </div>
  );
};

VerificationHeader.propTypes = {
  status: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  initialStatus: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default VerificationHeader;
